import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router';

import AuthLayout from '../layout/Auth/AuthLayout';
import DashboardLayout from '../layout/Dashboard/DashboardLayout';
import ChangePassword from '../pages/Auth/ChangePassword/ChangePassword';
import ChangePasswordVerificationConfirmation from '../pages/Auth/ChangePasswordVerificationConfirmation/ChangePasswordVerificationConfirmation';
import ForgotPassword from '../pages/Auth/ForgotPassword/ForgotPassword';
import ForgotPasswordNotification from '../pages/Auth/ForgotPasswordNotification/ForgotPasswordNotification';
import SignIn from '../pages/Auth/SignIn/SignIn';
import SignUp from '../pages/Auth/SignUp/SignUp';
import SignupVerification from '../pages/Auth/SignupVerification/SignupVerification';
import SignupVerificationConfirmation from '../pages/Auth/SignupVerification/SignupVerificationConfirmation';
import Dashboard from '../pages/Dashboard/Dashboard/Dashboard';
import DriverList from '../pages/Dashboard/DriverList/DriverList';
import DriverLookupInfo from '../pages/Dashboard/DriverLookupInfo/DriverLookupInfo';
import DriverPerformance from '../pages/Dashboard/DriverPerformance/DriverPerformance';
import DriverPerformanceExitReport from '../pages/Dashboard/DriverPerformanceExitReport/DriverPerformanceExitReport';
import DriverPerformanceReport from '../pages/Dashboard/DriverPerformanceReport/DriverPerformanceReport';
import DriverSetup from '../pages/Dashboard/DriverSetup/DriverSetup';
import HiringConflictsList from '../pages/Dashboard/HiringConflicts/HiringConflictsList';
import Lookup from '../pages/Dashboard/Lookup/Lookup';
import PaymentSuccessful from '../pages/Dashboard/PaymentSuccessful/PaymentSuccessful';
import Rating from '../pages/Dashboard/Rating/Rating';
import RatingSuccess from '../pages/Dashboard/RatingSuccess/RatingSuccess';
import AccountAndSecurity from '../pages/Dashboard/Settings/AccountAndSecurity/AccountAndSecurity';
import AccountManagement from '../pages/Dashboard/Settings/AccountManagement/AccountManagement';
import APIKeys from '../pages/Dashboard/Settings/APIKeys/APIKeys';
import ProfileSettings from '../pages/Dashboard/Settings/ProfileSettings/ProfileSettings';
import Settings from '../pages/Dashboard/Settings/Settings';
import SingleDriverSetup from '../pages/Dashboard/SingleDriverSetup/SingleDriverSetup';
import TripLog from '../pages/Dashboard/TripLog/TripLog';
import TripLogAddressBook from '../pages/Dashboard/TripLogAddressBook/TripLogAddressBook';
import VehicleList from '../pages/Dashboard/VehicleList/VehicleList';
import { NotFound404 } from '../pages/NotFound404';
import {
  ACCOUNT,
  ACCOUNT_AND_SECURITY,
  ACCOUNT_MANAGEMENT,
  ADDRESS_BOOK,
  API_KEYS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_VERIFICATION_CONFIRMATION,
  DASHBOARD,
  DRIVER_LIST,
  DRIVER_LOOKUP_INFO,
  DRIVER_PERFORMANCE,
  DRIVER_PERFORMANCE_EXIT_REPORT,
  DRIVER_PERFORMANCE_REPORT,
  DRIVER_SETUP,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_NOTIFICATION,
  HIRING_CONFLICTS,
  LOOKUP,
  NOTFOUND,
  PAYMENT_SUCCESS,
  PROFILE,
  RATING,
  RATING_SUCCESS,
  RESET_PASSWORD,
  SETTINGS,
  SIGNIN,
  SIGNUP,
  SIGNUP_VERIFICATION,
  SIGNUP_VERIFICATION_CONFIRMATION,
  SINGLE_DRIVER_SETUP,
  THIRD_PARTY_API_ACTIVATION,
  TRIP_LOG,
  VEHICLE_LIST,
} from './routeConstants';
import ThirdPartyApiGeneration from '../pages/Dashboard/ThirdPartyApiGeneration/ThirdPartyApiGeneration';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { path: '/', element: <Navigate to={DASHBOARD} /> },
      { path: DASHBOARD, element: <Dashboard /> },
      // { path: DASHBOARD, element: <Configuration /> },
      { path: DRIVER_SETUP, element: <DriverSetup /> },
      {
        path: SINGLE_DRIVER_SETUP,
        element: <SingleDriverSetup />,
      },
      { path: LOOKUP, element: <Lookup /> },
      { path: TRIP_LOG, element: <TripLog /> },
      { path: `${TRIP_LOG}/${ADDRESS_BOOK}`, element: <TripLogAddressBook /> },
      {
        path: `${DRIVER_LOOKUP_INFO}/:ninNumber/:jsonData`,
        element: <DriverLookupInfo />,
      },
      {
        path: `${DRIVER_LIST}?tab-segment=Drivers`,
        element: <DriverList />,
      },
      { path: DRIVER_LIST, element: <DriverList /> },
      {
        path: `${HIRING_CONFLICTS}`,
        element: <HiringConflictsList />,
      },
      { path: VEHICLE_LIST, element: <VehicleList /> },
      { path: DRIVER_PERFORMANCE, element: <DriverPerformance /> },
      {
        path: `${DRIVER_PERFORMANCE_REPORT}/:ninNumber/:driverId/:timeSpent/:name/:rating/:profilePicture/:verificationStatus`,
        element: <DriverPerformanceReport />,
      },
      {
        path: `${DRIVER_PERFORMANCE_EXIT_REPORT}/:ninNumber/:driverId/:timeSpent/:name/:rating/:profilePicture`,
        element: <DriverPerformanceExitReport />,
      },
      {
        path: SETTINGS,
        element: <Settings />,
        children: [
          {
            path: PROFILE,
            element: <ProfileSettings />,
          },
          {
            path: ACCOUNT_AND_SECURITY,
            element: <AccountAndSecurity />,
          },
          {
            path: ACCOUNT_MANAGEMENT,
            element: <AccountManagement />,
          },
          {
            path: API_KEYS,
            element: <APIKeys />,
          },
        ],
      },
      // { path: NOTIFICATIONS, element: <Notification /> },
      { path: NOTFOUND, element: <NotFound404 /> },
      { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
    ],
  },

  {
    path: ACCOUNT,
    element: <AuthLayout />,
    children: [
      { path: SIGNIN, element: <SignIn /> },
      { path: SIGNUP, element: <SignUp /> },
      { path: SIGNUP_VERIFICATION, element: <SignupVerification /> },
      {
        path: SIGNUP_VERIFICATION_CONFIRMATION,
        element: <SignupVerificationConfirmation />,
      },
      { path: CHANGE_PASSWORD, element: <ChangePassword /> },
      {
        path: CHANGE_PASSWORD_VERIFICATION_CONFIRMATION,
        element: <ChangePasswordVerificationConfirmation />,
      },
      { path: FORGOT_PASSWORD, element: <ForgotPassword /> },
      {
        path: FORGOT_PASSWORD_NOTIFICATION,
        element: <ForgotPasswordNotification />,
      },
      { path: NOTFOUND, element: <NotFound404 /> },
      { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
    ],
  },

  {
    path: RESET_PASSWORD,
    element: <ChangePassword />,
  },
  { path: PAYMENT_SUCCESS, element: <PaymentSuccessful /> },
  { path: THIRD_PARTY_API_ACTIVATION, element: <ThirdPartyApiGeneration /> },
  { path: `${RATING}/:tripId`, element: <Rating /> },
  { path: `${RATING_SUCCESS}`, element: <RatingSuccess /> },
  { path: '*', element: <NotFound404 /> },
]);
